// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.full-width-slider {
  width: 100% !important;
  max-width: 100% !important;
}
.full-width-slider .cds--slider-container,
.full-width-slider .cds--slider__track-container,
.full-width-slider .cds--slider {
  width: 100% !important;
}

.full-width-slider,
.full-width-slider * {
  touch-action: none;
}
.full-width-slider {
  overscroll-behavior: contain;
}

.full-width-slider [role="tooltip"],
.full-width-slider .cds--tooltip,
.full-width-slider .cds--popover {
  display: none !important;
  opacity: 0 !important;
  visibility: hidden !important;
  pointer-events: none !important;
}

.full-width-slider .cds--slider__track-container {
  position: relative;
  z-index: 1;
}
.full-width-slider .cds--slider__thumb {
  position: relative;
  z-index: 2;
  visibility: visible !important;
  opacity: 1 !important;
}

.tick-overlay {
  position: absolute;
  bottom: 16px;
  left: 24px;
  height: 8px;
  pointer-events: none;
  z-index: 0;
}
.tick {
  position: absolute;
  top: 0;
  width: 1px;
  height: 100%;
  background-color: #999;
  transform: translateX(-50%);
}

.value-bubble {
  position: absolute;
  bottom: 48px;
  transform: translateX(-50%);
  padding: 4px 8px;
  border-radius: 4px;
  background: #161616;
  color: #fff;
  font-size: 12px;
  line-height: 1;
  pointer-events: none;
  white-space: nowrap;
  z-index: 3;
}
.value-bubble__arrow {
  position: absolute;
  top: 100%;
  left: 50%;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #161616;
  transform: translateX(-50%);
}
.value-bubble--disabled {
  opacity: 0.5;
}

.mobile-action-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: flex;
  gap: 0.5rem;
  align-items: stretch;
  justify-content: space-between;
  background: #ffffff;
  border-top: 1px solid #e0e0e0;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.08);
  padding: 0.75rem calc(16px + env(safe-area-inset-right))
    calc(2rem + env(safe-area-inset-bottom))
    calc(16px + env(safe-area-inset-left));
}
.mobile-action-bar__left,
.mobile-action-bar__right {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.ai-progress {
  margin: 0 0 1rem 0;
}
.ai-progress__meta {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 6px;
  gap: 0.5rem;
}
.ai-progress__percent {
  font-weight: 700;
  font-size: 0.95rem;
}
.ai-progress__count {
  color: #6f6f6f;
  font-size: 0.85rem;
}
.ai-progress__track {
  position: relative;
  width: 100%;
  height: 8px;
  border-radius: 999px;
  background: #e0e0e0;
  overflow: hidden;
}
.ai-progress__fill {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 0%;
  background: #0f62fe;
  transition: width 160ms ease;
}

.thumb-dot {
  position: absolute;
  bottom: 12px;
  transform: translateX(-50%);
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #0f62fe;
  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px rgba(15, 98, 254, 0.15);
  pointer-events: none;
  z-index: 3;
}
.thumb-dot--disabled {
  background: #8d8d8d;
  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px rgba(0, 0, 0, 0.08);
  opacity: 0.7;
}

.mini-numinput {
  width: 80px;
  height: 32px;
  padding: 0 8px;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  border: 1px solid #8d8d8d;
  outline: none;
}
.mini-numinput:focus {
  border-color: #0f62fe;
  box-shadow: 0 0 0 2px rgba(15, 98, 254, 0.2);
}
.mini-numinput:disabled {
  background: #f4f4f4;
  color: #8d8d8d;
}

.inline-stepper .cds--btn {
  min-width: 36px;
  padding-left: 0;
  padding-right: 0;
}

.regen-remaining {
  font-size: 12px;
  color: #6f6f6f;
  line-height: 1.2;
  margin-top: 4px;
}
.regen-remaining.center {
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AiInterview.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;;;EAGE,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B;;AAEA;;;EAGE,wBAAwB;EACxB,qBAAqB;EACrB,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,0CAA0C;EAC1C;;0CAEwC;AAC1C;AACA;;EAEE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,SAAS;EACT,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gEAAgE;EAChE,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,4DAA4D;EAC5D,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".full-width-slider {\n  width: 100% !important;\n  max-width: 100% !important;\n}\n.full-width-slider .cds--slider-container,\n.full-width-slider .cds--slider__track-container,\n.full-width-slider .cds--slider {\n  width: 100% !important;\n}\n\n.full-width-slider,\n.full-width-slider * {\n  touch-action: none;\n}\n.full-width-slider {\n  overscroll-behavior: contain;\n}\n\n.full-width-slider [role=\"tooltip\"],\n.full-width-slider .cds--tooltip,\n.full-width-slider .cds--popover {\n  display: none !important;\n  opacity: 0 !important;\n  visibility: hidden !important;\n  pointer-events: none !important;\n}\n\n.full-width-slider .cds--slider__track-container {\n  position: relative;\n  z-index: 1;\n}\n.full-width-slider .cds--slider__thumb {\n  position: relative;\n  z-index: 2;\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n\n.tick-overlay {\n  position: absolute;\n  bottom: 16px;\n  left: 24px;\n  height: 8px;\n  pointer-events: none;\n  z-index: 0;\n}\n.tick {\n  position: absolute;\n  top: 0;\n  width: 1px;\n  height: 100%;\n  background-color: #999;\n  transform: translateX(-50%);\n}\n\n.value-bubble {\n  position: absolute;\n  bottom: 48px;\n  transform: translateX(-50%);\n  padding: 4px 8px;\n  border-radius: 4px;\n  background: #161616;\n  color: #fff;\n  font-size: 12px;\n  line-height: 1;\n  pointer-events: none;\n  white-space: nowrap;\n  z-index: 3;\n}\n.value-bubble__arrow {\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-top: 6px solid #161616;\n  transform: translateX(-50%);\n}\n.value-bubble--disabled {\n  opacity: 0.5;\n}\n\n.mobile-action-bar {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999;\n  display: flex;\n  gap: 0.5rem;\n  align-items: stretch;\n  justify-content: space-between;\n  background: #ffffff;\n  border-top: 1px solid #e0e0e0;\n  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.08);\n  padding: 0.75rem calc(16px + env(safe-area-inset-right))\n    calc(2rem + env(safe-area-inset-bottom))\n    calc(16px + env(safe-area-inset-left));\n}\n.mobile-action-bar__left,\n.mobile-action-bar__right {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.ai-progress {\n  margin: 0 0 1rem 0;\n}\n.ai-progress__meta {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 6px;\n  gap: 0.5rem;\n}\n.ai-progress__percent {\n  font-weight: 700;\n  font-size: 0.95rem;\n}\n.ai-progress__count {\n  color: #6f6f6f;\n  font-size: 0.85rem;\n}\n.ai-progress__track {\n  position: relative;\n  width: 100%;\n  height: 8px;\n  border-radius: 999px;\n  background: #e0e0e0;\n  overflow: hidden;\n}\n.ai-progress__fill {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 0%;\n  background: #0f62fe;\n  transition: width 160ms ease;\n}\n\n.thumb-dot {\n  position: absolute;\n  bottom: 12px;\n  transform: translateX(-50%);\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: #0f62fe;\n  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px rgba(15, 98, 254, 0.15);\n  pointer-events: none;\n  z-index: 3;\n}\n.thumb-dot--disabled {\n  background: #8d8d8d;\n  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px rgba(0, 0, 0, 0.08);\n  opacity: 0.7;\n}\n\n.mini-numinput {\n  width: 80px;\n  height: 32px;\n  padding: 0 8px;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: center;\n  border: 1px solid #8d8d8d;\n  outline: none;\n}\n.mini-numinput:focus {\n  border-color: #0f62fe;\n  box-shadow: 0 0 0 2px rgba(15, 98, 254, 0.2);\n}\n.mini-numinput:disabled {\n  background: #f4f4f4;\n  color: #8d8d8d;\n}\n\n.inline-stepper .cds--btn {\n  min-width: 36px;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.regen-remaining {\n  font-size: 12px;\n  color: #6f6f6f;\n  line-height: 1.2;\n  margin-top: 4px;\n}\n.regen-remaining.center {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
